<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item label="客户" prop="custom">
          <el-select v-model="dataForm.custom" clearable>
              <el-option v-for="(option,index) in customData|| []" 
              :key="index" :label="option.name" :value="option.id"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.key" placeholder="请输入配置名或云配码" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">查询</el-button>
        <el-button v-if="isAuth('bus:bussetting:save')" type="primary" @click="addOrUpdateHandle()">新增</el-button>
        <!-- <el-button v-if="isAuth('bus:bussetting:delete')" type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">批量删除</el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <!-- <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column> -->
      <el-table-column
        type="index"
        width="50"
        header-align="center"
        align="center"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        align="center"
        label="配置名">
      </el-table-column>
      <el-table-column
        prop="custom.name"
        header-align="center"
        align="center"
        label="客户">
      </el-table-column>
      <el-table-column
        prop="data.supportSystem.name"
        header-align="center"
        align="center"
        label="支持系统">
      </el-table-column>
      <el-table-column
        prop="machineCode"
        header-align="center"
        align="center"
        label="绑定机器码">
      </el-table-column>
      <el-table-column
        v-if="$store.state.user.userInfo.linkWxs || isAuth('bus:bussetting:admin')"
        prop="data.isWxsCustomJson"
        header-align="center"
        align="center"
        label="分配到小程序账户">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.data.isWxsCustomJson" @change="wxsCustomJsonChange(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="jsonFile"
        header-align="center"
        align="center"
        label="云配码">
        <template slot-scope="scope">
          <a v-if="isAuth('bus:bussetting:admin')" :href="$filePath+'data/'+scope.row.jsonFile+'.json'" target="_blank">{{scope.row.jsonFile}}</a>
          <span v-else-if="scope.row.machineCode || isAuth('bus:bussetting:ignoreMachine')">{{scope.row.jsonFile}}</span>
          <span v-else>请先绑定机器码</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isAuth('bus:bussetting:admin')"
        prop="createSysUser.username"
        header-align="center"
        align="center"
        label="创建用户">
      </el-table-column>
      <el-table-column
        prop="createtime"
        header-align="center"
        align="center"
        label="创建时间">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
          <el-button type="text" size="small" @click="copy(scope.row.id)">复制</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  import AddOrUpdate from './bussetting-add-or-update'
  export default {
    data () {
      return {
        dataForm: {
          key: '',
          custom: ''
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        customData: []
      }
    },
    components: {
      AddOrUpdate
    },
    activated () {
      var customId = this.$route.query.customId
      this.$set(this.dataForm, 'custom', customId ? Number(customId) : '')
      this.getDataList()
    },
    mounted() {
      this.getCustomData()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        this.$http({
          url: this.$http.adornUrl('/bus/bussetting/list'),
          method: 'get',
          params: this.$http.adornParams({
            'page': this.pageIndex,
            'limit': this.pageSize,
            'key': this.dataForm.key,
            'custId': this.dataForm.custom
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            for (var item of data.page.list) {
              item.data = JSON.parse(item.data)
            }
            this.dataList = data.page.list
            this.totalPage = data.page.totalCount
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addOrUpdateHandle (id) {
        this.$router.push(`/bussetting-add-or-update?id=${id || ''}`)
      },
      copy(id) {
        this.$router.push(`/bussetting-add-or-update?copyid=${id}`)
      },
      // 删除
      deleteHandle (id) {
        var ids = id ? [id] : this.dataListSelections.map(item => {
          return item.id
        })
        this.$confirm(`确定进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl('/bus/bussetting/delete'),
            method: 'post',
            data: this.$http.adornData(ids, false)
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      },
      // 获取下拉客户
      getCustomData() {
        this.$http({
          url: this.$http.adornUrl('/bus/buscustom/getList'),
          method: 'post',
          data: this.$http.adornData({})
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.customData = data.list
          }
        })
      },
      wxsCustomJsonChange(row){
        console.log(row.data.isWxsCustomJson)
        this.$http({
          url: this.$http.adornUrl(`/bus/bussetting/update`),
          method: 'post',
          data: this.$http.adornData({
            'id': row.id,
            'custId': row.data.custom,
            'name': row.data.title,
            'machineCode': row.data.machineCode,
            'data': JSON.stringify(row.data),
            'isWxsCustomJson': row.data.isWxsCustomJson,
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                // this.$router.go(-1)
              }
            })
          } else {
            this.$set(row.data,'isWxsCustomJson',false)
            this.$message.error(data.msg)
          }
        })
      }
    }
  }
</script>
